import { StoreTradingHour } from "../services/api/store/model";

export const isStoreOpenThisWeek = (tradingHours?: StoreTradingHour[]) => {
  return tradingHours
    ? tradingHours.some((storeHours) => !!storeHours.timePeriods.length)
    : false;
};
